import { GetterTree } from "vuex";
import { DispatchState, Guard, PatrolZone } from "./types";
import { RootState } from "@/store/types";

export const dispatchGetters: GetterTree<DispatchState, RootState> = {
	getDispatchedGuards: state => state.DispatchedGuards,
	getPatrolZonesList: state => state.PatrolZones,
	getGuardsList: state => {
		let guardsList = state.Guards;

		if (state.GuardsPatrolZoneListFilter > -1) {
			if (state.GuardsPatrolZoneListFilter === 0) {
				guardsList = state.Guards.filter(
					guard => Object.keys(guard.patrolZones).length === 0
				);
			} else {
				guardsList = state.Guards.filter(guard =>
					guard.patrolZones.hasOwnProperty(
						state.GuardsPatrolZoneListFilter
					)
				);
			}
		}

		if (state.GuardsCallsignListFilter) {
			const guardsCallsignListFilter = state.GuardsCallsignListFilter.toLowerCase();
			guardsList = (guardsList || state.Guards).filter(guard =>
				guard.callsign.toLowerCase().includes(guardsCallsignListFilter)
			);
		}

		return guardsList;
	},

	assignedGuards: (state, getters) =>
		getters.getGuardsList.filter(
			guard => guard.lastLocation && guard.patrolZones
		),

	getGuardByID: state => (guardId: number) =>
		state.Guards.filter((guard: Guard) => guard.guardID === guardId)[0],

	getEventGuardByID: state => (guardId: number) => {
		let result = state.EventGuards.filter(
			(guard: Guard) => guard.guardID === guardId
		)[0];
		if (!result) {
			result = state.DispatchedGuards.filter(
				(guard: Guard) => guard.guardID === guardId
			)[0];
		}
		return result;
	},

	getGuardForFilter: state => (guardId: number) =>
		state.GuardsForFilter.filter(
			(guard: Guard) => guard.guardID === guardId
		)[0],

	getPatrolZoneByID: state => (id: number) =>
		state.PatrolZones.filter(
			(zone: PatrolZone) => zone.patrolZoneID === id
		)[0],

	getGuardsForEvent: state => state.EventGuards,

	getGuardTypes: state => state.GuardTypes,

	getGuardStatus: state => (guardId: number) => {
		let result = 0;
		let guard = state.EventGuards.find(guard => guard.guardID === guardId);
		if(guard == null)
			guard = state.DispatchedGuards.find(guard => guard.guardID === guardId);

		if(guard != null)
			result = guard.status;
		return result;
	}
};
